import React, { useEffect, useState } from 'react';
import api from '@/lib/api';
import { PageHeader } from '@/components/app/PageHeader';
import { Card } from '@/components/ui/card';
import { formatINR, fmtDate } from '@/lib/format';
import { StatusPill } from '@/components/app/StatusPill';
import { Building2, MapPin, FileSignature } from 'lucide-react';

export default function TenantLease() {
  const [leases, setLeases] = useState([]);
  useEffect(() => { api.get('/leases').then(r => setLeases(r.data)); }, []);
  return (
    <div>
      <PageHeader title="My lease" subtitle="Lease agreements and key terms" />
      <div className="space-y-4">
        {leases.map((l) => (
          <Card key={l.id} className="p-5">
            <div className="flex items-start justify-between gap-3">
              <div>
                <div className="flex items-center gap-2">
                  <FileSignature className="h-4 w-4 text-muted-foreground" />
                  <div className="font-mono text-sm">{l.agreement_number}</div>
                  <StatusPill status={l.status} />
                </div>
                <div className="mt-2 text-lg font-semibold flex items-center gap-2"><Building2 className="h-4 w-4" /> {l.property_name}</div>
                <div className="text-xs text-muted-foreground flex items-center gap-1 mt-1"><MapPin className="h-3.5 w-3.5" /> Unit {l.unit_number}</div>
              </div>
              <div className="text-right text-sm">
                <div className="text-xs text-muted-foreground">Monthly rent</div>
                <div className="text-2xl font-display font-semibold tabular-nums">{formatINR(l.rent_amount)}</div>
                <div className="text-xs text-muted-foreground mt-2">Deposit</div>
                <div className="font-medium tabular-nums">{formatINR(l.deposit_amount)}</div>
              </div>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mt-4 text-sm">
              <div className="rounded-lg border p-3"><div className="text-xs text-muted-foreground">Start</div><div className="font-medium">{fmtDate(l.start_date)}</div></div>
              <div className="rounded-lg border p-3"><div className="text-xs text-muted-foreground">End</div><div className="font-medium">{fmtDate(l.end_date)}</div></div>
              <div className="rounded-lg border p-3"><div className="text-xs text-muted-foreground">Notice period</div><div className="font-medium">{l.notice_period_days} days</div></div>
              <div className="rounded-lg border p-3"><div className="text-xs text-muted-foreground">Lock-in</div><div className="font-medium">{l.lock_in_months} months</div></div>
            </div>
          </Card>
        ))}
        {!leases.length && <Card className="p-10 text-center text-muted-foreground">No leases.</Card>}
      </div>
    </div>
  );
}
